import Ls from './ls'
import axios from 'axios'
import store from '../store'

export default {
  async login(loginData) {
    await store.dispatch('user/setMyShift', null)
    await store.dispatch('user/setShiftsToActivate', null)

    try {
      let response = await axios.post('/api/auth/login', loginData)

      Ls.set('auth.token', response.data.token)
      Ls.set('api-token', response.data.api_token)
      // axios.defaults.headers.common.test = 'Bearer ';
      toastr['success']('Logged In!', 'Success')
      return response.data.token
    } catch (error) {
      toastr['error']('Invalid Credentials', 'Error')
      if (error.response.status === 401) {
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
    }
  },

  async logout() {
    try {
      await axios.get('/api/auth/logout')

      Ls.remove('auth.token');
      Ls.remove('api-token');
      await store.dispatch('user/setMyShift', null)
      await store.dispatch('user/setShiftsToActivate', null)
      await store.dispatch('user/setActiveWorkGroups', null)
      await store.dispatch('user/setActiveWorkGroup', null)
      // store.dispatch('platform/setStores', false);
      // axios.defaults.headers.common.Authorization = '';
      toastr['success']('Logged out!', 'Success')
    } catch (error) {
      console.log('Error', error.message)
    }
  },

  async check(deviceMac = null, updateStore = false) {
    let url = '/api/auth/check?';
    const stores = await store.getters['platform/stores'];
    const needUpdateData = await store.getters['auth/isNeedToUpdateLoginData'];
    let storeUpdate = false;
    if (updateStore || needUpdateData || !stores) {
      url += 'getStores=true'
      storeUpdate = true;
    }
    if (deviceMac) {
      url += (storeUpdate ? '&' : '') + 'd=' + deviceMac;
    }
    let response = await axios.get(url);
    await store.dispatch('auth/setUpdateLoginData', false)
    // let response2 = await axios.get('/api/auth/getToken')
    return response.data
  },

  async quickAccess(authData) {
    try {
      const {data} = await axios.post('/api/auth/quickAccess', {
        device_token: Ls.get('device-token'),
        code: authData.code,
        request_login: authData.requestLogin
      });
      if (data.success) {
        Ls.set('auth.token', data.token)
        Ls.set('api-token', data.api_token)
        if (data.device_token) {
          Ls.set('device-token', data.device_token)
        }
        return {success: true, newAccessCode: data.newAccessCode};
      }
    } catch (e) {
    }
    return false;
  },
  async updateShiftUserData(data) {
    await store.dispatch('user/setUserIsFreeToday', data.userIsFreeToday);
    await store.dispatch('permissions/setOrderAccess', data.orderAccess)
    await store.dispatch('user/setActiveWorkGroups', data.activeWorkGroups);
    await store.dispatch('platform/setPhoneLines', data.phoneLines);
    await store.dispatch('user/setPhoneNumbers', {'sipAccounts': data.sipAccounts, 'phoneNumbers': data.phoneNumbers});
  }
}
